import { EventBus } from 'core-components/classes/events/Bus'

export const partner360WidgetsBus = new EventBus(['planningRefresh'], 'partner360WidgetsBus')
